import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 18 25" fill={color}>
    <g id="Page-1">
      <g id="_x30_02C-Whole-Home-Data-Backup" transform="translate(-216.000000, -1016.000000)">
        <g id="Stacked-Group" transform="translate(195.000000, 892.000000)">
          <g id="Speed-up" transform="translate(22.000000, 125.000000)">
            <g id="location-icon">
              <path
                id="Path"
                style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeLinejoin: 'round' }}
                d="M16.5,8.2c0,4.6-8.2,15.7-8.2,15.7S0,12.8,0,8.2C0,3.7,3.7,0,8.2,0S16.5,3.7,16.5,8.2z"
              />
              <circle
                id="Oval"
                style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeLinejoin: 'round' }}
                cx="8.2"
                cy="8.2"
                r="3.3"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/locationicon.js